import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  DateField,
  EditButton
} from 'react-admin';

// own ui
import CustomFilterContestParticipantVideo from '../../ui/custom-filter-contest-participant-video';
import LinkField from '../../ui/link-field';
import ContestParticipantVideoExporter from '../../exporter/contest-participant-video-exporter';

const ContestParticipantVideoList = (props) => (
    <List
      title="Participantes Modalidade Vídeo" {...props}
      sort={{ field: 'id', order: 'desc' }}
      filters={ <CustomFilterContestParticipantVideo /> }
      filterDefaultValues={{ active: true }}
      bulkActionButtons={ false }
      exporter={ ContestParticipantVideoExporter } >
        <Datagrid
          rowClick="show">
          <TextField source="id" sortable={true} />
          <TextField source="contest_name" label="Concurso" sortable={false} />
          <TextField source="name" label="Nome" sortable={false} />
          <TextField source="document" label="CPF" sortable={false} />
          <TextField source="cellphone" label="Celular" sortable={false} />
          <LinkField source="url" text="Abrir" label="Vídeo" sortable={false}/>
          <BooleanField source="finalist" label="Finalista?" />
          <BooleanField source="winner" label="Vencedor?" />
          <TextField source="count_votes" label="Votos" sortable={false} />
          <DateField source="created_at" locales="pt-BR" label="Criado em" showTime sortable={false} />
          <EditButton />
        </Datagrid>
    </List>
);

export default ContestParticipantVideoList;
